import { render, staticRenderFns } from "./js-editor.vue?vue&type=template&id=180d9d76&"
import script from "./js-editor.vue?vue&type=script&lang=js&"
export * from "./js-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports